import { gql } from "@apollo/client";

export default gql`
  mutation setMeetingTopicCarryForwardMutation(
    $topicId: Int!
    $meetingId: Int!
    $carryForward: Boolean!
  ) {
    setMeetingTopicCarryForward(
      topicId: $topicId
      meetingId: $meetingId
      carryForward: $carryForward
    ) {
      meeting {
        id
      }
      occurrence {
        id
        isPinned
        carryForward
        canChangePin
        canUpdate {
          permission
        }
        editorDocumentName
        editorWebsocketToken
        topic {
          id
        }
      }
    }
  }
`;
